import { render, staticRenderFns } from "./SolutionPage4.vue?vue&type=template&id=120ecd40&scoped=true"
import script from "./SolutionPage4.vue?vue&type=script&lang=js"
export * from "./SolutionPage4.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "120ecd40",
  null
  
)

export default component.exports